// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-app-js": () => import("./../../../src/pages/app.js" /* webpackChunkName: "component---src-pages-app-js" */),
  "component---src-templates-news-template-js": () => import("./../../../src/templates/NewsTemplate.js" /* webpackChunkName: "component---src-templates-news-template-js" */),
  "component---src-templates-page-template-js": () => import("./../../../src/templates/PageTemplate.js" /* webpackChunkName: "component---src-templates-page-template-js" */),
  "component---src-templates-therapist-template-js": () => import("./../../../src/templates/TherapistTemplate.js" /* webpackChunkName: "component---src-templates-therapist-template-js" */),
  "component---src-templates-workshop-template-js": () => import("./../../../src/templates/WorkshopTemplate.js" /* webpackChunkName: "component---src-templates-workshop-template-js" */)
}

